import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
  Tab,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import PostHooks from "../../../../Api/PostHooks";
import AlertComponent from "../../../../Components/AlertComponent";

const LoanRepaymentTabs = ({ loan, onClose, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [value, setValue] = useState("1");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [loading, response, request] = PostHooks();
  const [payOffLoading, payOffResponse, payOffRequest] = PostHooks();

  const payOff = async () => {
    try {
      let formData = {
        loan_id: loan?.id,
        type: "paid_off",
      };

      const payResp = await payOffRequest({
        url: "/early_repayment",
        body: formData,
      });

      if (payResp && payResp.status === 200 && payResp.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Loan pay off successful!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          payResp?.data?.StatusMessage ??
          payResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      console.log("loan repayment payOff err", error);

      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  const earlyRepayment = async (e) => {
    try {
      let formData = {
        loan_id: loan?.id,
        type: "early",
        amount: e.amount,
      };

      const earlyResp = await request({
        url: "/early_repayment",
        body: formData,
      });

      if (
        earlyResp &&
        earlyResp.status === 200 &&
        earlyResp.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Loan early repayment successful!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          earlyResp?.data?.StatusMessage ??
          earlyResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      console.log("loan repayment early_repayment err", error);

      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  console.log(loan);

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="user tabs"
            allowScrollButtonsMobile
            variant="scrollable"
            textColor="secondary"
            indicatorColor="secondary"
            scrollButtons="auto"
          >
            <Tab label="Early repayment" value="1" />
            <Tab label="Pay off" value="2" />
          </TabList>
        </Box>

        <TabPanel value="1">
          <form onSubmit={handleSubmit(earlyRepayment)}>
            <Typography>Loan Amount: {loan?.principal_payable}</Typography>
            <FormControl
              fullWidth
              error={!!errors.amount}
              sx={{
                mt: "20px",
              }}
            >
              <InputLabel htmlFor="amount">Amount</InputLabel>
              <OutlinedInput
                id="amount"
                type="amount"
                {...register("amount", { required: true })}
                label="Username"
              />
              {errors.amount && (
                <FormHelperText>Please enter an amount!</FormHelperText>
              )}
            </FormControl>

            <Box
              sx={{
                gap: 2,
                pt: "40px",
                display: "flex",
                direction: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button variant="text" type="reset" onClick={() => onClose()}>
                Cancel
              </Button>
              <LoadingButton
                loading={loading}
                variant="contained"
                type="submit"
              >
                Submit
              </LoadingButton>
            </Box>
          </form>
        </TabPanel>

        <TabPanel value="2">
          <Typography>Loan Amount: {loan?.principal_payable}</Typography>
          <Box
            sx={{
              gap: 2,
              pt: "40px",
              display: "flex",
              direction: "row",
              justifyContent: "flex-end",
            }}
          >
            <Button variant="text" type="reset" onClick={() => onClose()}>
              Cancel
            </Button>
            <LoadingButton
              variant="contained"
              loading={payOffLoading}
              type="submit"
              onClick={payOff}
            >
              Pay Off
            </LoadingButton>
          </Box>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default LoanRepaymentTabs;
